// Persistence for the background-jobs banner. We keep the small job descriptors
// in localStorage so a page reload (or accidental close) resumes tracking an
// in-flight Lambda render — the poller re-asks render-status on rehydrate, so
// the durable state lives in S3, not here. The presigned `url` is volatile
// (TTL-bound) so it's never persisted; the poller re-fetches a fresh one.
//
// Storage is scoped PER ORG (`cg:bgJobs:${orgId}`) so switching Clerk orgs never
// surfaces one org's in-flight renders under another. The legacy un-scoped
// `cg:bgJobs` key (pre-scoping) is intentionally left orphaned — its entries are
// transient renders that the poller would drop anyway.

const KEY_PREFIX = 'cg:bgJobs';

const storageKey = (orgId) => `${KEY_PREFIX}:${orgId || 'none'}`;

export function loadJobs(orgId) {
  try {
    const raw = localStorage.getItem(storageKey(orgId));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveJobs(orgId, jobs) {
  try {
    // Drop the presigned URL — it expires and is always re-fetched by the poller.
    const slim = jobs.map(({ url, ...rest }) => rest);
    localStorage.setItem(storageKey(orgId), JSON.stringify(slim));
  } catch {
    /* private mode / quota — in-memory tracking still works for the session */
  }
}
